import { css } from '@linaria/core';

export const modalStyle = css`
	overflow: auto;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
`;
